import { render, staticRenderFns } from "./LineMessageBox.vue?vue&type=template&id=235f4ffa&scoped=true"
import script from "./LineMessageBox.vue?vue&type=script&lang=js"
export * from "./LineMessageBox.vue?vue&type=script&lang=js"
import style0 from "./LineMessageBox.vue?vue&type=style&index=0&id=235f4ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f4ffa",
  null
  
)

export default component.exports